 (function() {
  'use strict';

  // Utilities previously in swatches-common.js, now private to the element
  function getStyleTag(tags) {
    if (!Array.isArray(tags)) return null;
    const override = tags.find(t => typeof t === 'string' && t.indexOf('styleOverride:') === 0);
    if (override) return override;
    return tags.find(t => typeof t === 'string' && t.indexOf('style:') === 0) || null;
  }

  function getNamekeyTag(tags) {
    if (!Array.isArray(tags)) return null;
    return tags.find(t => typeof t === 'string' && t.indexOf('namekey:') === 0) || null;
  }

  function swatchImageForTagsOrFeatured(tags, featuredUrl) {
    const baseAssetUrl = (CD_STATE && CD_STATE.images && CD_STATE.images.placeholder) || '';
    const namekeyTag = getNamekeyTag(tags || []);
    if (namekeyTag) {
      const namekeyValue = namekeyTag.split(':')[1].replace('.', '_');
      return baseAssetUrl + 'swatch_' + namekeyValue + '.jpg';
    }
    return featuredUrl || '';
  }

  async function fetchProductsByStyleTag(styleTag) {
    const token = CD_STATE && CD_STATE.apis && CD_STATE.apis.storefrontAccessToken;
    const endpoint = CD_STATE && CD_STATE.apis && CD_STATE.apis.graphQlEndpoint;
    if (!styleTag || !token || !endpoint) return [];
    const query = `{
      products(first: 50, query: "tag:'${styleTag}'") {
        edges { node { handle title featuredImage { url } publishedAt tags } }
      }
    }`;
    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({ query })
      });
      const json = await res.json();
      const edges = json && json.data && json.data.products && json.data.products.edges ? json.data.products.edges : [];
      return edges.map(e => e.node);
    } catch (e) {
      console.warn('FHSwatchGroup fetch error', e);
      return [];
    }
  }

  function buildSwatchesHTML(products, currentHandle, currentProductTags, currentFallbackImage) {
    let html = '';
    const available = (products || []).filter(p => p.publishedAt !== null);
    available.sort((a, b) => a.handle.localeCompare(b.handle));
    const existsCurrent = available.some(p => p.handle === currentHandle);

    if (!existsCurrent && currentHandle) {
      const swatchImage = swatchImageForTagsOrFeatured(currentProductTags, currentFallbackImage);
      html += `<li class="product-color-swatches__item product-color-swatches__item--current">  
      <a href="#" class="product-color-swatches__item-link" data-handle="${currentHandle}">
      <img src="${swatchImage}" alt="">
      </a></li>`;
    }

    available.forEach(p => {
      const isCurrent = p.handle === currentHandle;
      const productUrl = isCurrent ? '#' : ('/products/' + p.handle);
      const imageUrl = swatchImageForTagsOrFeatured(p.tags || [], p.featuredImage && p.featuredImage.url);
      html += `<li class="product-color-swatches__item ${isCurrent ? 'product-color-swatches__item--current' : ''}">
      <a href="${productUrl}" class="product-color-swatches__item-link" data-handle="${p.handle}">
      <img src="${imageUrl}" alt="${p.title || ''}">
      </a></li>`;
    });

    return html;
  }

  function buildVariantAnchors(products, currentHandle, parentId) {
    var html = '';
    var available = (products || []).filter(function(p){ return p.publishedAt !== null; });
    available.sort(function(a, b){ return a.handle.localeCompare(b.handle); });
    available.forEach(function(p){
      var isCurrent = p.handle === currentHandle;
      var imageUrl = swatchImageForTagsOrFeatured(p.tags || [], p.featuredImage && p.featuredImage.url);
      var namekeyTag = getNamekeyTag(p.tags || []);
      var swatchName = namekeyTag ? namekeyTag.split(':')[1] : p.handle;
      var activeClass = isCurrent ? ' active' : '';
      var stitle = p.title;
      var productUrl = isCurrent ? '#' : ('/products/' + p.handle);
      html += `<a href="javascript:void(0)" data-url="${productUrl}" title-updated="true" data-product-title="${stitle}" title="${swatchName}" class="variant-item ${swatchName} ${activeClass}" data-product-handle="${p.handle}" data-id="${parentId}" data-action="0" data-colour="${swatchName}" style="background-image: url(${imageUrl});"></a>`;
    });
    return html;
  }

  class FHSwatchGroup extends HTMLElement {
    constructor() {
      super();
      this.isInitialized = false;
    }

    connectedCallback() {
      if (this.isInitialized) return;
      this.isInitialized = true;
      this.init();
    }

    init() {
      const handle = this.getAttribute('data-product-handle');
      const productId = this.getAttribute('data-product-id');
      const tagsStr = this.getAttribute('data-product-tags');
      const context = this.getAttribute('data-context') || 'card';
      const fallbackImage = this.getAttribute('data-fallback-image') || '';

      if (!handle || !tagsStr) return;

      let tags;
      try {
        tags = JSON.parse(tagsStr);
      } catch (e) {
        console.warn('FHSwatchGroup: Invalid JSON in data-product-tags', e);
        return;
      }

      const styleTag = getStyleTag(tags);
      if (!styleTag) {
        this.classList.add('hidden');
        return;
      }

      this.renderSkeleton(context);

      fetchProductsByStyleTag(styleTag)
        .then(products => {
          if (context === 'pdp') {
            this.renderPDPSwatches(products, handle, tags, fallbackImage);
          } else {
            this.renderCardSwatches(products, handle, productId);
          }
        })
        .catch(err => {
          console.warn('FHSwatchGroup fetch error:', err);
          this.classList.add('hidden');
        });
    }

    renderCardSwatches(products, currentHandle, productId) {
      const anchors = buildVariantAnchors(products, currentHandle, productId);
      if (!anchors.trim()) {
        this.classList.add('hidden');
        this.classList.remove('active');
        return;
      }
      this.innerHTML = anchors;
      this.classList.add('active');
      this.classList.remove('hidden');
      if (this.children && this.children.length >= 7) {
        this.classList.add('size_mb');
      }
      this.addVariantCounters();
    }

    renderPDPSwatches(products, currentHandle, tags, fallbackImage) {
      const itemsHtml = buildSwatchesHTML(products, currentHandle, tags, fallbackImage);
      if (!itemsHtml.trim()) {
        this.classList.add('hidden');
        return;
      }
      // Preserve original UL semantics for CSS selectors
      this.innerHTML = '<ul class="product-color-swatches__list">' + itemsHtml + '</ul>';
      this.classList.remove('hidden');
    }

    renderSkeleton(context) {
      var isPdp = context === 'pdp';
      var count = isPdp ? 5 : 4;
      var dots = '';
      for (var i = 0; i < count; i++) {
        dots += '<div class="dot"></div>';
      }
      this.innerHTML = '<div class="fh-swatch-skeleton">' + dots + '</div>';
    }

    addVariantCounters() {
      const oldCounters = this.querySelectorAll('.variant-count-num, .variant-count-total');
      oldCounters.forEach(el => el.remove());
      const items = this.querySelectorAll('.variant-item[title-updated="true"]');
      const count = items.length;
      if (count === 0) {
        this.classList.add('hidden');
        this.classList.remove('active');
        return;
      }
      const countElement = document.createElement('div');
      countElement.classList.add('variant-count-num', 'scc');
      countElement.textContent = count <= 1 ? (count + ' Colour') : (count + ' Colours');
      this.appendChild(countElement);
      if (count > 3) {
        const totalElement = document.createElement('div');
        totalElement.classList.add('variant-count-total', 'stt');
        totalElement.textContent = '+' + (count - 3);
        this.appendChild(totalElement);
      }
    }

  }

  if (!customElements.get('fh-swatch-group')) {
    customElements.define('fh-swatch-group', FHSwatchGroup);
  }
})();
